// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__25Ukb","header":"ClearentDisclaimer_header__3ZpyH","inner":"ClearentDisclaimer_inner__waSa-"};